import { Component, EventEmitter, Output } from '@angular/core';
import { BetSummaryService } from '../bet-summary/bet-summary.service';

@Component({
  selector: 'app-table-bet-summary',
  templateUrl: './table-bet-summary.component.html',
  styleUrls: ['./table-bet-summary.component.scss'],
})
export class TableBetSummaryComponent {
  public filterType = 'accountId';
  public searchValue = '';
  public startDateIso?: string;
  public endDateIso?: string;

  public page = 1;
  public pageSize = 20;
  public total = 0;

  public rows: any[] = [];

  @Output() rowsLoaded = new EventEmitter<any[]>();
  @Output() loadError = new EventEmitter<void>();

  constructor(private betSummaryService: BetSummaryService) {}

  load(): void {
    const startDate = this.startDateIso ?? '';
    const endDate = this.endDateIso ?? '';

    if (!startDate || !endDate) {
      this.rows = [];
      this.total = 0;
      this.rowsLoaded.emit(this.rows);
      return;
    }

    const params: any = {
      startDate,
      endDate,
      page: this.page,
      pageSize: this.pageSize,
    };

    const value = (this.searchValue || '').trim();
    if (value) {
      if (this.filterType === 'accountId') params.accountId = value;
      if (this.filterType === 'document') params.document = value.replace(/\D/g, '');
    }

    this.betSummaryService.getSummaryBet(params).subscribe({
      next: (resp: any) => {
        const list =
          resp?.summaryBet ??
          resp?.summaryBets ??
          resp?.items ??
          resp?.data ??
          resp?.result ??
          (Array.isArray(resp) ? resp : []);

        this.rows = Array.isArray(list) ? list : [];
        this.total = resp?.total ?? resp?.totalCount ?? resp?.count ?? this.rows.length;
        this.rowsLoaded.emit(this.rows);
      },
      error: () => {
        this.rows = [];
        this.total = 0;
        this.rowsLoaded.emit(this.rows);
        this.loadError.emit();
      },
    });
  }

  pageChange(): void {
    this.load();
  }
}